'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../styled/components');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaultStyles = {};

exports.default = function (_ref) {
  var style = _ref.style,
      className = _ref.className;
  var customStyles = Object.assign({}, defaultStyles, style);
  return _react2.default.createElement(_components.ThemedSvg, {
    style: customStyles,
    width: '16',
    height: '16',
    viewBox: '0 0 16 16',
    xmlns: 'http://www.w3.org/2000/svg',
    className: className
  }, _react2.default.createElement('g', {
    id: 'project-list-1200',
    fillRule: 'evenodd'
  }, _react2.default.createElement('g', {
    id: '555.1-Project-detail-fully-funded',
    transform: 'translate(-912 -748)'
  }, _react2.default.createElement('g', {
    id: 'Group-5',
    transform: 'translate(240 143)'
  }, _react2.default.createElement('g', {
    id: 'Group-11',
    transform: 'translate(23 509)'
  }, _react2.default.createElement('g', {
    id: 'Group-2',
    transform: 'translate(649 96)'
  }, _react2.default.createElement('circle', {
    id: 'Oval',
    cx: '8',
    cy: '8',
    r: '8'
  }), _react2.default.createElement('g', {
    className: 'no-override',
    transform: 'translate(0 2)',
    fill: '#FFF'
  }, _react2.default.createElement('path', {
    className: 'no-override',
    d: 'M6.32717016,3.20473399 C6.11671576,3.23358661 5.93341677,3.35748315 5.82818957,3.54078214 L3.03466351,7.0332662 C2.84797009,7.35913108 2.96168335,7.77325103 3.28754823,7.95994445 C3.61341311,8.14663786 4.02753306,8.0329246 4.21422648,7.70705972 L6.56477997,4.98680753 L11.8399529,10.156518 C12.1047182,10.4212832 12.534113,10.4229805 12.8005754,10.1582152 C13.0653407,9.89345003 13.0670379,9.46405517 12.8022727,9.19759274 L6.92968074,3.42876609 L6.89743369,3.39651904 C6.76844551,3.26753086 6.5953298,3.19794514 6.41712244,3.19794514 C6.38657261,3.19794514 6.35771999,3.19964235 6.32717016,3.20473399 Z',
    id: 'Shape',
    transform: 'matrix(1 0 0 -1 0 13.554)'
  }))))))));
};